import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserI } from 'src/app/interfaces/user.interface';
import { AuthLoginService } from 'src/app/pages/login/services/auth-login.service';

@Directive({
  selector: '[permission]',
})
export class TemplateDirective {
  @Input() set permission(allowedPermissions: string[]) {
    this.checkPermissions(allowedPermissions)
      .then((hasPermission) => {
        if (hasPermission) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      })
      .catch((error) => {
        console.error(error);
        this.viewContainer.clear();
      });
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private readonly authService: AuthLoginService
  ) {}

  private user!: UserI;

  private async checkPermissions(
    allowedPermissions: string[]
  ): Promise<boolean> {
    try {
      const userState = await this.authService.returnUserInfoV2('LOADED');

      if (!userState) return false;
      const { user } = userState;

      this.user = user;
      const permission = this.user.superuser
        ? true
        : allowedPermissions.some((allowPermission) => {
            return (
              this.user.permission?.some(
                (permission) => permission.name === allowPermission
              ) || this.user.lob?.some((lob) => lob.name === allowPermission)
            );
          });
      return permission;
    } catch (e) {
      return false;
    }
  }
}
